class Collage {
    #_offset = 0
    #running = false
    #collage

    get #offset() {
        return (-50 + 80 * this.#_offset).toString()
    }

    set #offset(value) {
        this.#_offset = value
        this.#collage.style.setProperty("--offset", this.#offset)
    }

    #initScrollListener() {
        window.addEventListener(
            "scroll",
            () => {
                if (this.#running) return
                else this.#running = true

                this.#handleScroll()

                this.#running = false
            },
            { passive: true }
        )
    }

    #handleScroll() {
        const { top, bottom } = this.#collage.getBoundingClientRect()
        this.#setOffset(top, bottom)
    }

    /**
     * @param {number} value 
     */
    #setOffset(top, bottom) {
        const viewport = window.innerHeight

        if (bottom > 0 && top < viewport)
            this.#offset = top / viewport
    }

    /** 
     * @param {HTMLDivElement} parent 
     */
    constructor(parent) {
        this.#collage = parent
        this.#initScrollListener()
    }
}

document.querySelectorAll("[id$=Collage]")
    .forEach(collage => new Collage(collage))